// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wlecomsign {
  color: white;
  font-size: 1.5rem;
  position: relative;
  text-align: right;
  top: 35%;
  right: 10%;
}`, "",{"version":3,"sources":["webpack://./src/pages/admcrm/styles/adm.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,QAAA;EACA,UAAA;AACJ","sourcesContent":[".wlecomsign {\n    color: #ffff;\n    font-size: 1.5rem;\n    position: relative;\n    text-align: right;\n    top: 35%;\n    right: 10%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
